/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import CheckBoxNew from "../common_input/CheckBoxNew";
import PreviewReferrenceData from "../common_field/PreviewReferrenceData";
import PreviewReferrenceData2D from "../common_field/PreviewReferrenceData2D";
import FormulaCard from "../common_field/FormulaCard";
import DataTypesSelection from "../common_field/DataTypesSelection";
import TableFormula from "../common_field/TableFormula";
import ConditionalStatementInput from "../common_field/ConditionalStatementInput";
import { Dropdown } from "../reuseable";

/*REDUX*/
import {
  pushFieldForm,
  push_field_form_reorder,
} from "../../App/actions/layerActions";

/*PICTURE*/
import referrence_2d_file from "../../Assets/file/[2d-referrence]-[comma-delimited-UTF8].csv";
import referrence_simple_file from "../../Assets/file/[simple-referrence]-[comma-delimited-UTF8].csv";

/*FUNCTION*/
import uuid from "../../App/validation/uuid";
import { data_types } from "../../App/validation/data_types";
import { handle_upload_csv } from "../../App/validation/handle_file";
import { getAllFieldsFromGeoLayerWoGeojson } from "../../App/reduxHelper/layer";
import { simpleConvertFieldsToHeaders } from "../../App/validation/convert_data";

/*DATA*/
import dict from "../../Data/dict.json";
import tipe_1_string_array from "../../Data/tipe_1_string_array.json";

/*CONST*/

class PushFieldForm extends Component {
  state = {
    name: "",
    description: "",
    type: "text",
    tag: "",
    array_templates: [],
    isRequired: true,
    isAllowOtherAnswer: true,
    min: 0,
    max: 10,
    step: 1,
    poi_type: "", //FASILITAS PENDIDIKAN || TEMPAT IBADAH
    poi_rad: 1, //radius counting
    unit: "",
    decimal_digits: null,
    reference_list: [],
    reference_key: "",
    formula: [],
    value: "",
    reference_list_2d: {
      row_name: "",
      column_name: "",
      headers: [],
      features: [],
    },
    conditional_statement_list: [],
    table_formula: {
      field_parent_uuid: "",
      field_child_uuid: "",
      formula: "", // ex: "sum" or "avg"
    },
  };

  componentDidMount() {
    const { _id } = this.props.auth.user;
    this.setState({ user_id: _id });
  }

  on_change = (e) => {
    e.preventDefault();
    const target = e.target;
    const value = target.value;
    const name = target.name;
    if (["tag"].includes(name)) {
      this.setState({ [name]: value }, () => {
        const tagArray = value.split("\n");
        const array_templates = tagArray.map((value, idx) => {
          return { name: value, index: idx };
        });
        let field = {
          array_templates,
          defaultValue: "",
        };
        const is_any_equal_to_value = array_templates.some(
          ({ name }) => name === this.state?.value
        );
        if (!is_any_equal_to_value) field.value = "";
        this.setState(field);
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  set_table_formula = (table_formula) => {
    this.setState({
      table_formula,
    });
  };

  handle_value_template = (new_value) => {
    const { value } = this.state;
    this.setState({
      value: value !== new_value ? new_value : "",
    });
  };

  handleConditionalStatementList = (value) => {
    let { conditional_statement_list } = this.state;
    conditional_statement_list = value;
    this.setState({
      conditional_statement_list,
    });
  };

  handleCsvValidation2dReferring = async (e) => {
    const { reference_list_2d } = this.state;
    const file = await handle_upload_csv(e);
    const headers = file?.headers;
    // ?.map((field) => field.toUpperCase());
    let is_valid = "invalid";

    if (headers?.includes("index_name")) {
      is_valid = "valid";
    }
    if (is_valid === "valid") {
      this.setState({
        reference_list_2d: {
          ...reference_list_2d,
          headers: headers,
          features: file.data,
        },
      });
    }
  };

  handleDecimalInput = (e) => {
    if (
      /[0-9]/.test(e.nativeEvent.data) ||
      e.nativeEvent.inputType === "deleteContentBackward"
    ) {
      this.setState({
        decimal_digits: e.target.value,
      });
    }
  };

  handleRowSelect = (value) => {
    const { reference_list_2d } = this.state;
    let new_ref = reference_list_2d;
    new_ref["row_name"] = value;
    this.setState({
      reference_list_2d: new_ref,
    });
  };

  handleColumnSelect = (value) => {
    const { reference_list_2d } = this.state;
    let new_ref = reference_list_2d;
    new_ref["column_name"] = value;
    this.setState({
      reference_list_2d: new_ref,
    });
  };

  handleFormula = (value) => {
    this.setState({
      formula: value,
    });
  };

  handleToggle = (name) => {
    this.setState({
      [name]: !this.state[name],
    });
  };

  handleClickType = (dataType, layerType) => {
    if (
      !this.isDataTypeCalculateDimensionAndLayerTypeIsPoint(dataType, layerType)
    ) {
      this.setState({ type: dataType });
    }
  };

  isDataTypeCalculateDimensionAndLayerTypeIsPoint = (dataType, layerType) => {
    if (layerType === "Point" && dataType === "calculate_dimension") {
      return true;
    } else return false;
  };

  referColumn = (e) => {
    this.setState({
      reference_key: e.target.value,
    });
  };

  handleCsvValidation = async (e) => {
    const file = await handle_upload_csv(e);
    const headers = file?.headers?.map((field) => field.toUpperCase());
    let is_valid = "invalid";

    if (headers?.includes("NAME") && headers?.includes("VALUE")) {
      is_valid = "valid";
    }

    if (is_valid === "valid") {
      this.setState({
        reference_list: file.data,
      });
    }
  };

  handleSubmit = async (e) => {
    // e.preventDefault();

    const {
      name,
      description,
      type,
      min,
      max,
      step,
      array_templates,
      isRequired,
      isAllowOtherAnswer,
      poi_type,
      poi_rad,
      unit,
      reference_list,
      reference_key,
      formula,
      value,
      reference_list_2d,
      conditional_statement_list,
      table_formula,
    } = this.state;

    const uuid_value = uuid();
    let field = {
      uuid: uuid_value,
      key: uuid_value,
      // name.replace(/ /g, "_").replace(/[^\w\s]/gi, ""),
      name: name || type.replaceAll("_", " "),
      description,
      type: type,
      array_templates,
      isHighlight: false,
      isRequired,
      isAllowOtherAnswer,
      date: Date.now(),
      isHide: false,
      min,
      max,
      step,
      poi_type,
      poi_rad,
      unit,
      reference_list,
      reference_key,
      formula,
      value,
      reference_list_2d,
      conditional_statement_list,
      table_formula,
    };

    const { mode_middle, to_uuid } = this.props;
    if (mode_middle) {
      let body = {};

      const geo_layer = this.props.layer.geo_layer_wo_geojson.geo_layer;

      const parent_uuid = this.props.parent_uuid;
      if (parent_uuid) {
        field = { ...field, parent_uuid };
      }

      body = {
        geo_layer_id: geo_layer._id,
        field,
        fields: geo_layer.fields,
        to_uuid,
      };

      await this.props.push_field_form_reorder(body);

      this.setState({
        name: "",
        description: "",
        type: "text",
        tag: "",
        array_templates: [],
        isRequired: true,
        isAllowOtherAnswer: true,
        unit: "",
        reference_list: [],
        reference_key: "",
        reference_list_2d: {},
        decimal_digits: null,
        value: "",
        table_formula: {
          field_parent_uuid: "",
          field_child_uuid: "",
          formula: "",
        },
      });

      // this.props.setFieldList(
      //   this.props.layer?.geo_layer_wo_geojson?.geo_layer?.fields?.filter(
      //     (f) => !f.parent_uuid && !f.isStyle
      //   )
      // );
    } else {
      let body = {};
      if (this.props.from === "table") {
        body = {
          geo_layer_id: this.props.layer_id,
          field,
        };
        await this.props.pushFieldForm(body);
      } else {
        const geo_layer = this.props.layer.geo_layer_wo_geojson.geo_layer;

        const parent_uuid = this.props.parent_uuid;
        if (parent_uuid) {
          field = { ...field, parent_uuid };
        }

        body = {
          geo_layer_id: geo_layer._id,
          field,
        };

        await this.props.pushFieldForm(body);

        // this.props.setFieldList(
        //   this.props.layer?.geo_layer_wo_geojson?.geo_layer?.fields?.filter(
        //     (f) => !f.parent_uuid && !f.isStyle
        //   )
        // );
      }

      this.setState({
        name: "",
        description: "",
        type: "text",
        tag: "",
        array_templates: [],
        isRequired: true,
        isAllowOtherAnswer: true,
        unit: "",
        reference_list: [],
        reference_key: "",
      });
    }
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const {
      name,
      description,
      type,
      min,
      max,
      step,
      array_templates,
      tag,
      isRequired,
      isAllowOtherAnswer,
      poi_type,
      poi_rad,
      reference_list,
      formula,
      value,
      reference_list_2d,
      decimal_digits,
      conditional_statement_list,
      table_formula,
    } = this.state;

    //global props
    const { loadingProcess } = this.props.layer;
    const { layer } = this.props;

    //content
    const geometry_type = layer?.geo_layer_wo_geojson?.geo_layer?.type;
    const fields = getAllFieldsFromGeoLayerWoGeojson(layer)?.filter(
      (item) => !item.isStyle
    );
    const headers = simpleConvertFieldsToHeaders(fields);

    let button_content;

    if (loadingProcess) {
      button_content = (
        <div className="button_big background_black">
          {dict["Add Question"][language]}...
        </div>
      );
    } else {
      button_content = (
        <button
          type="submit"
          className="button_big background_black"
          onClick={this.handleSubmit.bind(this)}
          data-mapid="clickAdd"
        >
          {dict["Add Question"][language]}
        </button>
      );
    }

    const content = (
      <>
        {this.props.parent_uuid && (
          <p className="text_bold margin_bottom text_center">
            {dict["Add sub questions"][language]}
          </p>
        )}
        <section
          className="container background_grey_light outline_grey"
          style={{ marginBottom: "15px" }}
        >
          <p className="text_bold">{dict["Question name/title"][language]}</p>
          <input
            type="text"
            name="name"
            id="name"
            placeholder={dict["Question name/title"][language]}
            value={name}
            onChange={this.on_change}
            data-mapid="changeQuestionTitle"
          />
          <CheckBoxNew
            text="isRequired"
            title={dict["Required to fill by respondent"][language]}
            value={isRequired}
            handle={this.handleToggle.bind(this, "isRequired")}
          />
        </section>
        <section
          className="container background_grey_light outline_grey"
          style={{ marginBottom: "15px" }}
        >
          <p className="text_bold">{dict["Description"][language]}</p>
          <textarea
            rows="4"
            type="text"
            name="description"
            id="description"
            placeholder={dict["Describe this question here"][language]}
            value={description}
            onChange={this.on_change}
            data-mapid="changeQuestionDeskriptionTitle"
          />
        </section>
        <section
          className="container background_grey_light outline_grey"
          style={{ marginBottom: "15px" }}
        >
          <p className="text_bold">{dict["Type data"][language]}</p>

          <DataTypesSelection
            field={this.state}
            geo_layer_type={geometry_type}
            language={language}
            data_type={data_types(language)}
            handleDataTypeOnClick={this.handleClickType}
            isDataTypeCalculateDimensionAndLayerTypeIsPoint={
              this.isDataTypeCalculateDimensionAndLayerTypeIsPoint
            }
          />

          {type === "range" && (
            <>
              <p className="text_bold">{dict["Minimum value"][language]}</p>
              <input
                type="number"
                name="min"
                id="min"
                placeholder={dict["Minimum value"][language]}
                value={min}
                onChange={this.on_change}
                data-mapid="inputMinimum"
              />
              <p className="text_bold">{dict["Maximum value"][language]}</p>
              <input
                type="number"
                name="max"
                id="max"
                placeholder={dict["Maximum value"][language]}
                value={max}
                onChange={this.on_change}
                data-mapid="inputMaximum"
              />
              <p className="text_bold">{dict["Step value"][language]}</p>
              <input
                type="number"
                name="step"
                id="step"
                placeholder={dict["Step value"][language]}
                value={step}
                onChange={this.on_change}
                data-mapid="inputStep"
              />
            </>
          )}
        </section>

        {["selection", "radio_button", "checklist"].includes(type) && (
          <main
            className="container background_grey_light outline_grey"
            style={{ marginBottom: "15px" }}
          >
            <section className="text_bold">
              {dict["Value template"][language]}
            </section>
            <CheckBoxNew
              text="isAllowOtherAnswer"
              title={dict["Allow other answers"][language]}
              value={isAllowOtherAnswer}
              handle={this.handleToggle.bind(this, "isAllowOtherAnswer")}
            />
            <textarea
              type="text"
              name="tag"
              id="tag"
              value={tag}
              onChange={this.on_change.bind(this)}
              rows="5"
              data-mapid="inputJawaban"
            />
            <section className="input_note">
              {
                dict[
                  "Fill in if you want to provide several value options for attribute input (in MAPID FORM). Separate between values ​​with next values ​​with enter."
                ][language]
              }
            </section>
            <div className="flex gap_5 marginTop_10">
              {(array_templates || []).map((content, idx) => {
                const is_active = value === content.name && value !== "";
                return (
                  <main key={idx}>
                    <div
                      onClick={() => this.handle_value_template(content.name)}
                      style={{
                        border: "1px solid #b4b6b8",
                      }}
                      className={`h_20 w_fit padding_5 rounded_5 pointer noselect ${
                        is_active ? "button_active" : "button_inactive"
                      }`}
                    >
                      {content.name}
                    </div>
                    <br />
                  </main>
                );
              })}
            </div>
          </main>
        )}

        {type === "counting_poi" && (
          <main
            className="container background_grey_light outline_grey"
            style={{ marginBottom: "15px" }}
          >
            <p className="text_bold">
              {
                dict?.[
                  "Select the POI category to count the number of POIs."
                ]?.[language]
              }
            </p>
            <select
              id="poi_type"
              name="poi_type"
              value={poi_type}
              onChange={this.on_change}
            >
              <option value="">
                {dict?.["Select a point of interest theme"]?.[language]}
              </option>
              {tipe_1_string_array.map((item, idx) => {
                return (
                  <option key={idx} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>
            <p className="text_bold">
              {dict?.["Set POI radius from surveyor point (km)"]?.[language]}
            </p>
            <input
              id="poi_rad"
              name="poi_rad"
              value={poi_rad}
              type="number"
              onChange={this.on_change}
              className="full_width"
            />
            {poi_rad < 1 && (
              <section>
                {poi_rad} km = {poi_rad * 1000} meter
              </section>
            )}
          </main>
        )}

        {type === "simple_referring" && (
          <main className="container background_grey_light outline_grey">
            <div className="flex gap_10 paddingTop_10">
              <a
                className="button_big background_black"
                href={referrence_simple_file}
                data-mapid="clikcDownload"
              >
                <div className="center_perfect w_full h_full">
                  Template CSV Download
                </div>
              </a>

              <label className="inline">
                <div className="button_big background_black">
                  {"Upload CSV"}
                </div>
                <input
                  style={{ display: "none" }}
                  type="file"
                  accept=".csv*"
                  onChange={this.handleCsvValidation}
                  data-mapid="clikcUpload"
                />
              </label>
              {reference_list?.length > 0 && (
                <PreviewReferrenceData
                  field={this.state}
                  data={reference_list}
                  layer_id={
                    this?.props?.layer?.geo_layer_wo_geojson?.geo_layer?._id
                  }
                />
              )}
            </div>
            <div className="paddingTop_10">
              <label htmlFor="refer_to_column" className="font_18">
                Referred by
              </label>
              <select
                id="reference_list"
                name="reference_list"
                onChange={this.referColumn}
                data-mapid="selectSection"
              >
                <option key="" value="">
                  Select Column
                </option>
                {fields.map((head) => {
                  return (
                    <option key={head.key} value={head.key}>
                      {head.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </main>
        )}

        {type === "table_formula" && (
          <main className="container background_grey_light outline_grey paddingTop_10 marginBottom_15">
            <TableFormula
              language={language}
              table_formula={table_formula}
              set_table_formula={this.set_table_formula}
            />
          </main>
        )}

        {type === "2d_referring" && (
          <main className="container background_grey_light outline_grey">
            <div>
              <label className="font_18 w_full">2D Referring</label>
              <div className="flex gap_10 paddingTop_10">
                <a
                  className="button_big background_black"
                  href={referrence_2d_file}
                  data-mapid="clikcDownload2d"
                >
                  <div className="center_perfect w_full h_full">
                    Template CSV Download
                  </div>
                </a>
                <label className="inline">
                  <div className="button_big background_black">
                    {dict["Upload CSV"][language]}
                  </div>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept=".csv*"
                    onChange={this.handleCsvValidation2dReferring}
                    data-mapid="clikcUpload2d"
                  />
                </label>
                {reference_list_2d.features?.length > 0 && (
                  <PreviewReferrenceData2D data={reference_list_2d} />
                )}
              </div>

              <section className="two_container_equal">
                <div>
                  <label className="text_medium sub_color">
                    {
                      dict[
                        "Select column name from main table that will refer as a row in secondary table"
                      ][language]
                    }
                  </label>
                  <Dropdown
                    placeholder={dict["Select"][language]}
                    filter_on
                    is_enable_empty
                    onChange={(value) => {
                      this.handleRowSelect(value);
                    }}
                    data-mapid="clickSelectType1"
                  >
                    {fields?.map((header) => {
                      return (
                        <option key={header.key} value={header.key}>
                          {header.name}
                        </option>
                      );
                    })}
                  </Dropdown>
                </div>
                <div>
                  <label className="text_medium sub_color">
                    {
                      dict[
                        "Select column name from main table that will refer as a column in secondary table"
                      ][language]
                    }
                  </label>
                  <Dropdown
                    placeholder={dict["Select"][language]}
                    filter_on
                    is_enable_empty
                    onChange={(value) => {
                      this.handleColumnSelect(value);
                    }}
                    data-mapid="clickSelectType2"
                  >
                    {fields?.map((header) => {
                      return (
                        <option
                          key={header.key}
                          value={header.key}
                          data-mapid="selectType2"
                        >
                          {header.name}
                        </option>
                      );
                    })}
                  </Dropdown>
                </div>
              </section>
            </div>
          </main>
        )}

        {type === "math_operators" && (
          <main className="container background_grey_light outline_grey paddingTop_10">
            <FormulaCard
              formula={formula}
              headers={headers}
              handleFormula={this.handleFormula}
            />
            <div>
              <label className="font_18 w_full">Decimal</label>
              <div>
                <label className="w_full">Insert a decimal point</label>
                <div>
                  <label>Places:</label>
                  <input
                    type="number"
                    required={true}
                    onChange={this.handleDecimalInput}
                    value={decimal_digits}
                    min={0}
                  />
                </div>
              </div>
            </div>
          </main>
        )}

        {type === "conditional_statement" && (
          <main className="container background_grey_light outline_grey paddingTop_10 marginBottom_15">
            <ConditionalStatementInput
              language={language}
              headers={headers}
              handleConditionalStatementList={
                this.handleConditionalStatementList
              }
              conditional_statement_list={conditional_statement_list}
            />
          </main>
        )}

        <section className="text_center">{button_content}</section>
      </>
    );

    return <div style={{ minHeight: "100vh" }}>{content}</div>;
  }
}

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  pushFieldForm,
  push_field_form_reorder,
})(PushFieldForm);
